import * as React from "react";
import { useLoaderData, useNavigate } from "react-router-dom";
import Title from "../Common/Title";
import { Box, IconButton, Tooltip } from "@mui/material";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import EditIcon from "@mui/icons-material/Edit";
import FavoriteIcon from "@mui/icons-material/Favorite";
import {
  DataGrid,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import { formatDate } from "../../Utils/util-service";

export default function VendorList() {
  const { data: vendors, status } = useLoaderData();
  const navigate = useNavigate();
  const [rows, setRows] = React.useState([]);
  React.useEffect(() => {
    setRows(vendors);
  }, [vendors]);
  const goToVendorDetail = (vendorId) => {
    navigate("/vendor/" + vendorId);
  };
  const goToVendorEdit = (vendorId) => {
    navigate("/vendors/create?vendorId=" + vendorId);
  };
  const goToVendorWishlist = (vendorId) => {
    navigate("/vendor/" + vendorId + "/wishlist");
  };
  const columns = [
    // {
    //   field: "lastEstimate",
    //   headerName: "Last Estimate",
    //   headerClassName: "table--header",
    //   headerAlign: "center",
    //   align: "center",
    //   flex: 1,
    //   renderCell: (params) => (
    //     <span>
    //       {params.row.lastEstimate ? formatDate(params.row.lastEstimate) : "--"}
    //     </span>
    //   ),
    // },
    {
      field: "name",
      headerName: "Name",
      headerClassName: "table--header",
      headerAlign: "center",
      align: "center",
      flex: 2,
      renderCell: (params) => (
        <span>
          {params.row.name} ({params.row.nickName})
        </span>
      ),
    },
    {
      field: "phoneNumber",
      headerName: "Phone Number",
      headerClassName: "table--header",
      headerAlign: "center",
      align: "center",
      flex: 1,
    },
    {
      field: "city",
      headerName: "City",
      headerClassName: "table--header",
      headerAlign: "center",
      align: "center",
      flex: 1,
    },
    {
      field: "createdAt",
      headerName: "Joined Date",
      headerClassName: "table--header",
      headerAlign: "center",
      align: "center",
      flex: 1.5,
      renderCell: (params) => (
        <span>
          {params.row.createdAt ? formatDate(params.row.createdAt) : "--"}
        </span>
      ),
    },
    {
      field: "updatedAt",
      headerName: "Last Update",
      headerClassName: "table--header",
      headerAlign: "center",
      align: "center",
      flex: 1.5,
      renderCell: (params) => (
        <span>
          {params.row.updatedAt ? formatDate(params.row.updatedAt) : "--"}
        </span>
      ),
    },
    {
      field: "menu",
      headerName: "Action",
      headerClassName: "table--header",
      headerAlign: "center",
      align: "center",
      flex: 1,
    },
  ];

  const coloumnWithMenu = columns?.map((column, idx) => {
    if (column.field === "menu") {
      return {
        ...column,
        renderCell: (params) => (
          <>
            <span>
              <Tooltip title="Edit" placement="top">
                <IconButton
                  onClick={() => goToVendorEdit(params.row.vendorID)}
                  color="info"
                >
                  <EditIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Expand" placement="top">
                <IconButton
                  onClick={() => goToVendorDetail(params.row.vendorID)}
                  color="info"
                >
                  <FullscreenIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Wishlist" placement="top">
                <IconButton
                  onClick={() => goToVendorWishlist(params.row.vendorID)}
                  color="info"
                >
                  <FavoriteIcon />
                </IconButton>
              </Tooltip>
            </span>
          </>
        ),
      };
    }
    return column;
  });

  function CustomToolbar() {
    return (
      <GridToolbarContainer sx={{ mb: 10, mt: 2, ml: 2 }}>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <Box sx={{ flexGrow: 1 }} />
        <GridToolbarQuickFilter />
      </GridToolbarContainer>
    );
  }
  return (
    <React.Fragment>
      <Title>Vendors</Title>
      <DataGrid
        rows={rows}
        columns={coloumnWithMenu}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 25,
            },
          },
          sorting: {
            sortModel: [{ field: "updatedAt", sort: "desc" }],
          },
        }}
        pageSizeOptions={[25, 50, 100]}
        sx={{
          boxShadow: 2,
          border: 2,
          borderColor: "primary.light",
          "& .MuiDataGrid-cell:hover": {
            color: "primary.main",
          },
          "& .table--header": {
            backgroundColor: "rgb(231 225 225 / 60%)",
            fontFamily: "inherit",
            fontWeight: "400",
          },
        }}
        slots={{ toolbar: CustomToolbar }}
        slotProps={{
          toolbar: {
            showQuickFilter: true,
          },
        }}
        disableRowSelectionOnClick
        disableDensitySelector
      />
    </React.Fragment>
  );
}
